import { render, staticRenderFns } from "./selectProductModal.vue?vue&type=template&id=4884401c&scoped=true"
import script from "./selectProductModal.vue?vue&type=script&lang=js"
export * from "./selectProductModal.vue?vue&type=script&lang=js"
import style0 from "./selectProductModal.vue?vue&type=style&index=0&id=4884401c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4884401c",
  null
  
)

export default component.exports